export default __webpack_public_path__ + "static/media/scroll3.427de386.jpg";